module.exports = __webpack_public_path__ + "img/thumbblacksheep1.43a5e13c.png";